import { Stripe, loadStripe } from '@stripe/stripe-js';

export let stripe: Stripe | null;

const initStripe = async () => {
  stripe = await loadStripe(process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY!);
};

initStripe();
